import React from 'react';
import { ProgramCard } from '../components/ProgramCard';
import { accentByIndex } from '../lib/accents';

const ProgramsPage: React.FC = () => {
    const programs = [
        {
            title: "IT Essentials & Office Suite",
            description: "Master essential productivity tools like Microsoft Excel and Access. Enhance your efficiency for the modern workplace.",
            tags: ["Beginner", "Productivity", "Business"],
            imageUrl: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=2070&auto=format&fit=crop"
        },
        {
            title: "Python Bootcamp",
            description: "Go from beginner to building real-world applications with the world's most popular programming language.",
            tags: ["Beginner-Friendly", "12 Weeks", "Project-Based"],
            imageUrl: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?q=80&w=2074&auto=format&fit=crop"
        },
        {
            title: "Introduction to Web Development",
            description: "Master the fundamentals of web development with HTML, CSS, and JavaScript to build your first websites.",
            tags: ["Beginner-Friendly", "8 Weeks", "Portfolio Building"],
            imageUrl: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?q=80&w=2070&auto=format&fit=crop"
        },
        {
            title: "Data Literacy Workshops",
            description: "Learn to read, understand, create, and communicate data as information in this hands-on workshop series.",
            tags: ["All Levels", "4 Weeks", "Practical Skills"],
            imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop"
        },
    ];

  return (
    <div>
      <section className="py-16 text-center bg-muted">
        <div className="container mx-auto px-6">
          <p className="text-sm font-bold tracking-widest text-secondary uppercase mb-3 opacity-0 animate-fade-in-up">Learn With Us</p>
          <h1 className="text-4xl font-bold text-foreground font-heading opacity-0 animate-fade-in-up">Our <span className="text-primary">Programs</span></h1>
          <p className="text-lg text-muted-foreground mt-4 max-w-3xl mx-auto opacity-0 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Our programs are designed to serve as pivotal leverage for scalability across the greater Accra surrounding villages where digital literacy is needed the most.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {programs.map((program, index) => (
                    <div key={program.title} className="opacity-0 animate-fade-in-up" style={{ animationDelay: `${index * 100}ms` }}>
                        <ProgramCard {...program} accent={accentByIndex(index)} />
                    </div>
                ))}
            </div>
        </div>
      </section>
    </div>
  );
};

export default ProgramsPage;